export default {

    methods: {
        selectDates(from) {
            this.closeModal()
            eventBus.$emit('open-add-dates-to-list-dialog', {
                form: this.form,
                from: from
            })
        },
    },

    computed: {
        inputDateValue() {
            if (this.form.trip_date == null && this.form.trip_days == null) {
                return ''
            }
            if (this.form.trip_date) {
                let fromDate = moment(this.form.trip_date).utc()
                let newDate = moment(this.form.trip_date).utc().add((this.form.trip_days - 1), 'days')
                return fromDate.format('MMM Do') + ' to ' + newDate.format('MMM Do')
            }
            return this.form.trip_days + ' ' + this.pluralize('Day', this.form.trip_days);
        }
    }
}
